(function () {
  'use strict'

  require('./content')

  var MODULE_NAME = 'thismoment.content'

  angular
    .module(MODULE_NAME, [
      'thismoment.content.core'
    ])

  module.exports = MODULE_NAME
})()



// WEBPACK FOOTER //
// ./src/content/index.js